import React, { useState } from "react";
import "./style.scss";
import { downArrow } from "./icons"
// import { useSelector } from "react-redux";

export function ImgIcon({ style, className, size, iconSize, src, onClick, cursor, cover, bg, ...otherProps }) {
	return <span
		className={"imgIcon " + (className || "")}
		onClick={onClick}
		style={{
			backgroundImage: `url("${src}")`,
			backgroundRepeat: "no-repeat",
			backgroundPosition: "center",
			backgroundColor: bg ? bg : undefined,
			height: size || 50,
			width: size || 50,
			lineHeight: `${size || 50}px`,
			textAlign: "center",
			fontWeight: "bold",
			display: "inline-block",
			cursor: cursor ? cursor : (onClick ? "pointer" : "default"),
			fontSize: "0.8rem",
			...(iconSize ? { backgroundSize: iconSize } : { backgroundSize: cover ? "cover" : "contain" }),
			...(style || {})
		}}
		{...otherProps}
	/>
}

export function Spinner({ size = 26, color = "#ffffff", style = {}, fullscreen }) {

	let appliedStyle = {
		width: size,
		height: size
	}
	if (fullscreen) {
		appliedStyle = {
			position: "fixed",
			top: "50%",
			left: "50%",
			transform: "translate(-50%, -50%)",
			...appliedStyle,
			...style
		}
	}

	return (
		<span
			className="spinner lds-dual-ring"
			style={appliedStyle}
		>
			<span className="inner" style={{
				width: size * 0.8,
				height: size * 0.8,
				borderWidth: size * 0.15,
				borderColor: `${color} transparent ${color} transparent`
			}} />
		</span>
	)
}

export function BrandButton({ children, className = "", disabled = false, onClick, ...props }) {
	// const { featureColor1, featureColor2 } = useSelector(state => state.vendor);
	return <button
		className={`brandButton ${className}`}
		onClick={e => {
			if (disabled) return;
			if (onClick) onClick(e);
		}}
		disabled={disabled}
		{...props}
	// style={{
	// 	...style,
	// 	backgroundColor: featureColor1 || "grey",
	// 	color: featureColor2 || "white"
	// }}
	>{children}</button>
}

export function Radio({ options, onChange, value, color }) {

	return <div className="radio-field">
		{options.map(([option, label]) => (
			<div
				key={option}
				className={`option option-${value === option ? "current" : "unselected"}`}
				onClick={e => {
					if (value !== option) onChange(option);
				}}
			>
				<CheckBox color={color} checked={value === option} /> <span>{label || option}</span>
			</div>
		))}
	</div>
}

export function CheckBox({ checked, color, size = 18, onChange, ...props }) {
	return <span
		{...props}
		className={`checkbox noSelect checkbox-${checked ? "checked" : "unchecked"}`}
		onClick={e => {
			if (onChange) onChange(!checked);
		}}
		style={{
			...(color && checked ? { borderColor: color } : {}),
			height: size,
			width: size
		}}
	>
		<span className="inner brand-c text-center" style={{
			...(color ? { backgroundColor: color } : {}),
			fontSize: size * 1.2 + "px",
			lineHeight: size * 0.6 + "px"
			// height: size * 0.9,
			// width: size * 0.9
		}}>&#10004;</span>
	</span>
}

export function Dropdown({ options, value, onSelect, placeholder = "Select", height = 150, ...props }) {

	let displayValue = (options.find(o => o.value === value) || {}).name;

	const [open, setOpen] = useState(false)

	return <div className={"dropdown" + (open ? " open" : "")} {...props}>
		<div
			className="current-value"
			onClick={() => {
				setOpen(!open);
			}}
		>
			{displayValue || placeholder}
			<img src={downArrow} alt="chevron icon" className='downArrow' />
		</div>
		<div
			className={"options"}
			style={{ maxHeight: height }}
		>
			{options.map(option => {
				return (
					<div
						key={option.value}
						className="option"
						onClick={() => {
							setOpen(false)
							onSelect(option.value);
						}}
					>
						{option.name}
					</div>
				)
			})}
		</div>
	</div>
}

export function Hamburger({ value, onChange }) {
	return (
		<div
			className={"hamburger" + (value ? " open" : "")}
			onClick={() => {
				onChange(!value)
			}}
		>
			<span />
			<span />
			<span />
			<span />
		</div>
	)
}

export function SwitchField({ value, onChange = () => { }, size = 40, round = true, disabled = false }) {
	const space = size / 10;
	return <div
		disabled={disabled}
		style={{
			height: size,
			width: size * 2,
			...(round ? { borderRadius: size } : {})
		}}
		className={[
			"switch",
			value === true && "switch-on",
			value === false && "switch-off",
			disabled && "disabled"
		].filter(c => c).join(" ")}
		onClick={e => {
			if (!disabled) onChange(!value);
		}}
	>
		<div className="switch-inner" style={{
			top: space,
			left: (() => {
				if (typeof value === "boolean") {
					return value ? space + size : space
				} else {
					return space + (size / 2);
				}
			})(),
			height: size - (space * 2),
			width: size - (space * 2),
			...(round ? { borderRadius: size } : {})
		}} />
	</div>
}

export function YesNoField({ value, onChange, size = 55, fontSize = "2rem" }) {
	return <div className={[
		"yesNoField",
		"inline-children",
		"v-middle",
		value === true && "yesNoField-yes",
		value === false && "yesNoField-no",
	].filter(c => c).join(" ")}>
		<div style={{
			lineHeight: `${size}px`,
			fontSize
		}} className="no" onClick={e => {
			if (value !== false) onChange(false)
		}}>
			No
		</div>
		<div className="switchWrap">
			<SwitchField
				size={size}
				round={false}
				value={value}
				onChange={onChange}
			/>
		</div>
		<div style={{
			lineHeight: `${size}px`,
			fontSize
		}} className="yes" onClick={e => {
			if (value !== true) onChange(true)
		}}>
			Yes
		</div>
	</div>
}